import { render, staticRenderFns } from "./AlertBadges.vue?vue&type=template&id=3245e03f&scoped=true&"
import script from "./AlertBadges.vue?vue&type=script&lang=js&"
export * from "./AlertBadges.vue?vue&type=script&lang=js&"
import style0 from "./AlertBadges.vue?vue&type=style&index=0&id=3245e03f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245e03f",
  null
  
)

export default component.exports